import PostTranslation from './PostTranslation';
import DiscussionTranslation from './DiscussionTranslation';
import PollTranslation from './PollTranslation';
import PollOptionTranslation from './PollOptionTranslation';
export const models = {
  PostTranslation,
  DiscussionTranslation,
  PollTranslation,
  PollOptionTranslation
};
flarum.reg.add('fof-translate', 'common/models', null);